<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    transition="scale-transition"
    offsetY
    :left="left ? left : false"
    z-index="1109"
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        :label="label"
        :value="dateFormatted"
        :name="name"
        readonly
        :prepend-icon="showIcon ? 'event' : null"
        :append-icon="datePicked && !noClear ? 'close' : ''"
        @click:append="cleanValue"
        :error-messages="datePicked || !required ? '' : 'El campo Fecha de Alta es obligatorio'"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="datePicked"
      :max="max"
      :locale="locale"
      :min="min ? min : '1950-01-01'"
      :allowed-dates="allowDates"
      @input="selectDate"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">
        {{ resx.labels.cancel }}
      </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)">
        {{ resx.labels.ok }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
"use strict";

import store from "../../store/store";
import moment from "moment";
import { default as config } from "../../store/modules/config";

// const ISO_DATE_REGEXP = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
// const DD_MM_YYYY_REGEXP = /d{4}-\d{2}-\d{2}/;

export default {
  name: "datepicker",
  computed: {
    dateFormatted() {
      return this.datePicked ? this.format(this.datePicked) : null;
    }
  },
  data: () => ({
      datePicked: null,
      menu: false,
      locale: config.state.defaultLocale,
    }),
  methods: {
    selectDate() {
      this.$emit("input", moment(this.datePicked).toISOString());
      this.menu = false;
    },
    format(date) {
      return moment(date).format(store.state.constants.DATE_FORMAT);
    },
    cleanValue() {
      this.datePicked = null;
      this.$emit("input", null);
    }
  },
  props: [
    "value",
    "name",
    "label",
    "max",
    "min",
    "allowDates",
    "showIcon",
    "noClear",
    "left",
    "required"
  ],
  watch: {
    value: {
      handler: function(val) {
        this.datePicked = val ? val.substr(0, 10) : val;
      },
      immediate: true
    }
  }
};
</script>
